import React, { useEffect, useState, useRef } from 'react'
import { InlineMath } from 'react-katex'

const RectangleContent = (props) => {
  const { contentType, contentData } = props

  return (
    <div className='rectangle-content-container'>
      {contentType === 'text' ? (
        <span className='rectangle-content-text'>{contentData}</span>
      ) : contentType === 'inktotext' ? (
        <span className='rectangle-content-inktotext'>
          <InlineMath>{contentData}</InlineMath>
        </span>
      ) : (
        <img
          src={contentData}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: '10px'
          }}
          alt='image'
          draggable='false'
        />
      )}
    </div>
  )
}

export { RectangleContent }
